import {createFormHook} from '@tanstack/react-form'

import {fieldContext, formContext} from './formContexts.js'
import TextField from './TextField.js'

export {fieldContext, formContext, useFieldContext, useFormContext} from './formContexts.js'

export const {useAppForm, withForm} = createFormHook({
  fieldComponents: {TextField},
  formComponents: {},
  fieldContext,
  formContext
})
